<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>流向调整</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <!-- 源编码 = SF 合作产品期间往来(PPPA)的编号。同步失败/被拒绝的告警里给的就是这个值，
                     没有这个输入框的话，人拿到告警在列表里翻不到对应单据 -->
                <el-input
                    v-model="queryParams.source_code"
                    placeholder="请输入源编码(PPPA...)"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <vDropdownMul
                    model_key="approval_status"
                    model_name="请选择审批状态"
                    select_value="value"
                    request_uri="dropdownApprovalStatus"
                    :request_params="{ type: 3 }"
                    :model_value_default="queryParams['approval_status']"
                    @onDropChange="onDropChange"
                    ref="approval_status_ref"
                ></vDropdownMul>
            </div>
            <div class="main_header_item">
                <vDropdownMul
                    model_key="allotment_status"
                    model_name="请选择分配状态"
                    select_value="value"
                    request_uri="dropdownReceivableAllotmentStatus"
                    :model_value_default="queryParams['allotment_status']"
                    @onDropChange="onDropChange"
                    ref="allotment_status_ref"
                ></vDropdownMul>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="representative_rid"
                    model_name="请选择代表"
                    :model_value_default="queryParams['representative_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="representative_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.flow_rids" placeholder="请输入流向RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item" v-show="false">
                <vDropdown
                    model_key="calculation_basis"
                    model_name="请选择计算依据"
                    select_value="value"
                    request_uri="dropdownReceivableCalculationBasis"
                    :model_value_default="queryParams['calculation_basis']"
                    @onDropChange="onDropChange"
                    ref="calculation_basis_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type_code"
                    model_name="请选择类型"
                    select_value="value"
                    request_uri="dropdownReceivableAdjustmentType"
                    :model_value_default="queryParams['type_code']"
                    @onDropChange="onDropChange"
                    ref="type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" :loading="btnLoading">新增</el-button>
                <el-button size="small" plain @click="allotment(1)" :loading="btnLoading">批量分配</el-button>
                <el-button size="small" plain @click="allotment(2)" :loading="btnLoading">批量重分配</el-button>
                <el-button size="small" plain @click="approval(1)" :loading="btnLoading" icon="el-icon-success">批量批准</el-button>
                <el-button size="small" plain @click="approval(2)" :loading="btnLoading" icon="el-icon-error">批量撤销</el-button>
                <el-button size="small" plain @click="syncFromSf" :loading="btnLoading" icon="el-icon-refresh">同步SF</el-button>
                <el-button size="small" plain @click="toLine()">查看调整行</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="commodity_flow_adjustment" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >批量分配：默认分配所有审批状态为：草稿、已撤销的且分配状态为分配失败、未分配的，如果存在筛选，只分配筛选结果（默认忽略已批准、已分配的）。如果数据量大，耗时会较久，中途请勿操作合作产品路径、流向、关闭浏览器、断开网络等</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >批量重分配：分配逻辑大致和批量分配一致。区别：已分配未批准的也会进行重新分配</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >批量批准：根据复选框选中项将审批状态为草稿或已撤销的且已分配完成的标记为已批准。标记成功后会同步更新流向EQM</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >批量撤销：根据复选框选中项将审批状态为已批准的标记为已撤销。标记成功后会同步反更新流向EQM</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >分配规则只会找PPA流向，即：经过流向状态重算并且存在流向扩展的流向。如果流向状态发生变化，请按需进行批量撤销、批量重分配后再次批量批准</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >同步SF：把 SF 合作产品期间往来（勾选了「是否同步」且状态为已通过的）拉成草稿单，应收和流向两类一次都处理。只建单，不会自动分配或审批。定时任务每天凌晨也会跑一次。与应收调整列表页那个按钮功能完全相同</span
                    >
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow_adjustment"
                @header-dragend="changeColWidth"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <el-table-column type="selection" width="50" align="center"></el-table-column>

                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['rid'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common.js';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect,
        vDropdownMul
    },
    name: 'commodityFlowAdjustmentComponent',
    data() {
        return {
            draggable: {
                data_name: 'commodity_flow_adjustment'
            },
            is_show_help: false,
            taskQueueMessage: [],
            down_loading: false,
            loading: true,
            btnLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            selected: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
            // 展开时才拉，避免每次进列表页都多一个请求
            if (this.is_show_help) {
                this.initTaskQueueMessage();
            }
        },
        handleSelectionChange(val) {
            this.selected = [];
            val.forEach((element) => {
                this.selected.push(element['rid']);
            });
            return true;
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['rid']) && row.rid) {
                this.$router.push({
                    path: '/commodityFlowAdjustmentDetail',
                    query: {
                        id: row.rid
                    }
                });
            }
        },
        toLine() {
            this.$router.push({
                path: '/commodityFlowAdjustmentLineList',
                query: {}
            });
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };
            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_adjustment_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_flow_adjustment_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_adjustment', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_adjustment;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'commodityFlowAdjustmentLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'commodityFlowAdjustmentEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'commodityFlowAdjustmentDelete', row.name);
        },
        //新增
        insert() {
            this.$router.push({
                path: 'commodityFlowAdjustmentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        // 批量分配
        allotment(t) {
            this.queryParams.allotment_type = t;
            if (t == 1) {
                var msg = '您确定要进行分配吗？';
            } else {
                var msg = '您确定要进行重分配吗？';
            }
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['commodityFlowAdjustmentAllotment'](this.queryParams)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.btnLoading = false;
                });
        },
        approval(t) {
            if (this.selected.length == 0) {
                this.$message({
                    message: '请至少选择一行!',
                    type: 'error'
                });
                return false;
            }

            this.queryParams.allotment_type = t;
            if (t == 1) {
                var msg = '您确定要批量批准吗？';
                var method = 'commodityFlowAdjustmentApproval';
            } else {
                var msg = '您确定要批量撤销吗？';
                var method = 'commodityFlowAdjustmentRevoke';
            }
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api[method]({ rids: this.selected })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功!',
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {
                    this.btnLoading = false;
                });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'commodityFlowAdjustmentEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        // 上一次「同步SF」的执行结果。后端在 syncFromSf 跑完时用
        // TaskQueueService::insertFinished(code=sync_sf_adjustment) 补了一条日志——
        // 这轮可能跑到浏览器超时，那条记录是唯一的事后凭据。
        // 应收调整页也展示同一条，因为一次同步把两张表都处理了。
        initTaskQueueMessage() {
            this.$api['taskQueueMessage']({ code: ['sync_sf_adjustment'] })
                .then((res) => {
                    this.taskQueueMessage = res.code == 0 ? res.data : [];
                })
                .catch(() => {
                    this.taskQueueMessage = [];
                });
        },
        // 「同步SF」：跟应收调整列表页那个按钮是同一个接口、同一个行为。
        // 一次调用把应收和流向两张表都处理了（后端按 SF 的 Type__c 分流），
        // 两边各放一个只是为了在哪个页面都点得到，不是两个独立的同步。
        syncFromSf() {
            this.$confirm('将从 SF 拉取最近 2 天变动的合作产品期间往来，建成草稿单（不会自动分配或审批）。应收和流向两类会一起处理。确定同步吗？', '同步SF', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['adjustmentSyncFromSf']({})
                        .then((res) => {
                            this.btnLoading = false;
                            if (res.code != 0) {
                                return;
                            }
                            var data = res.data || {};
                            // 刷新任务日志，帮助信息开着的话立刻能看到这一轮的结果
                            this.initTaskQueueMessage();
                            var items = (data.rejected || []).concat(data.failed || []);
                            if (items.length === 0) {
                                this.$message({ message: data.summary || '同步完成', type: 'success' });
                                this.getList();
                                return;
                            }
                            // 拒绝和失败要人处理，逐条列出来——只报个数字的话，
                            // 人不知道是哪张单，也就没法处理
                            var html = '<div style="max-height:320px;overflow:auto">';
                            html += '<p style="margin:0 0 8px">' + (data.summary || '') + '</p>';
                            items.forEach(function (v) {
                                var why = v.reason || v.message || '';
                                html += '<p style="margin:4px 0;font-size:12px">' + v.source_code + (v.rid ? ' → ' + v.rid : '') + '：' + why + '</p>';
                            });
                            html += '</div>';
                            this.$alert(html, '同步完成，有 ' + items.length + ' 条需人工处理', {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '知道了'
                            });
                            this.getList();
                        })
                        .catch(() => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        reset() {
            this.initQueryParams();
            this.$refs.approval_status_ref && this.$refs.approval_status_ref.reset();
            this.$refs.allotment_status_ref && this.$refs.allotment_status_ref.reset();
            this.$refs.representative_rid_ref && this.$refs.representative_rid_ref.reset();
            this.$refs.product_rid_ref && this.$refs.product_rid_ref.reset();
            this.$refs.calculation_basis_ref && this.$refs.calculation_basis_ref.reset();
            this.$refs.type_code_ref && this.$refs.type_code_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>